export default __webpack_public_path__ + "static/media/chevron-down.451215b1.svg";